/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { FortigateStats } from "../../models/fortigate-stats";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface GetFortigateStats$Params {
  subscriptionId: string;
  start?: number | null;
  end?: number | null;
  step?: number;
  raw?: boolean;
}

export function getFortigateStats(
  http: HttpClient,
  rootUrl: string,
  params: GetFortigateStats$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<FortigateStats>> {
  const rb = new RequestBuilder(rootUrl, getFortigateStats.PATH, "get");
  if (params) {
    rb.path("subscriptionId", params.subscriptionId, {});
    rb.query("start", params.start, {});
    rb.query("end", params.end, {});
    rb.query("step", params.step, {});
    rb.query("raw", params.raw, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json; charset&#x3D;utf-8", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FortigateStats>;
    }),
  );
}

getFortigateStats.PATH = "/dashboard/stats/nfv/{subscriptionId}";
